export function loadRecaptcha() {
  const url = "https://www.google.com/recaptcha/api.js";
  const queryString = "?render="+process.env.VUE_APP_RECAPTCHA_KEY;
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url + queryString;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
}
